import type {GraphAtom} from "../../graph/GraphAtom"
import {MolecularGraph} from "../../graph/MolecularGraph"
import {Feature, Features} from "../../feature";
import {rGroupFinder} from "../../util/rGroupFinder";
import {extractorUtil} from "../../util/extractorUtil";
import {halogen_elements} from "./halogens";

const getAlkylHalideName = (symbol: string) => {
    if(symbol === "F") return Features.alkylFlouride;
    else if(symbol === "Cl") return Features.alkylChloride;
    else if(symbol === "Br") return Features.alkylBromide;
    else if(symbol === "I") return Features.alkylIodide;
    else if(symbol === "As") return Features.alkylAstatide;
    else if(symbol === "Ts") return Features.alkylTenneside;
    else return Features.alklyHalid;
}

export const alkylHalideExtrator = {
    extract: (graph: MolecularGraph) => {
        const halogens = halogen_elements.reduce((acc, e) => {
            return [...acc, ...extractorUtil.getFunctionalGroupRootsWithElement(e, graph)]
        }, [] as GraphAtom[]);
        const features: Feature[] = [];
        while(halogens.length > 0) {
            const h = halogens.pop()!;
            const connectedBonds = graph.getBondsAttachedTo(h);
            if(connectedBonds.length === 1 && connectedBonds[0].order === 1) {
                const r = rGroupFinder.get(graph, [h]);
                features.push({
                    name: getAlkylHalideName(h.symbol),
                    atoms: [h],
                    connections: r
                })
            }
        }

        return features;
    }
}
